"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reduce;
exports.getActiveReminders = getActiveReminders;
var types = _interopRequireWildcard(require("../actions/actionTypes"));
var _concat = _interopRequireDefault(require("lodash/concat"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any. The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

const initialState = {
  reminders: []
};
function reduce() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case types.REMINDERS_FETCHED:
      const listWithDuplicates = (0, _concat.default)(action.reminders, state.reminders);
      return {
        ...state,
        reminders: listWithDuplicates.filter((i, ind) => listWithDuplicates.map(a => a.id).indexOf(i.id) === ind)
      };
    case types.MARK_REMINDER_AS_SHOWN:
      return {
        ...state,
        reminders: state.reminders.filter(item => {
          let found = false;
          for (let i = 0; i < action.ids.length; ++i) {
            if (item.id === action.ids[i]) {
              found = true;
              break;
            }
          }
          return !found;
        })
      };
    case types.MARK_ALL_REMINDERS_AS_SHOWN:
      return {
        ...state,
        reminders: []
      };
    default:
      return state;
  }
}
function getActiveReminders(state) {
  return state.reminders.reminders;
}